import { useEffect, useState, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { AuthContext } from './AuthContext';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';

const AuthProvider = ({ children }) => {
  const [usuario, setUsuario] = useState(null);
  const [token, setToken] = useState(null);
  const [loadingPreloader, setLoadingPreloader] = useState(true);
  const navigate = useNavigate();

  const handleLogin = useCallback((data) => {
    setUsuario(data.user);
    setToken(data.token);

    localStorage.setItem("user", JSON.stringify(data.user));
    localStorage.setItem("token", data.token);
    setLoadingPreloader(false);

    const permisos = data.user.permisos || [];
    if (permisos.includes("menu_dashboard")) {
      navigate("/admin", { replace: true });
    } else if (permisos.includes("menu_sales")) {
      navigate("/admin/ventas", { replace: true });
    }else if (permisos.includes("menu_reported_web")) {
      navigate("/admin/reportadas", { replace: true });
    }else if (permisos.includes("menu_welcome_web")) {
      navigate("/admin/bienvenida", { replace: true });
    }else if (permisos.includes("leads")) {
      navigate("/admin/leads", { replace: true });
    }else if (permisos.includes("menu_recruitment")) {
      navigate("/admin/reclutamiento", { replace: true });
    }else if (permisos.includes("menu_rrhh")) {
      navigate("/admin/rrhh", { replace: true });
    } else {
      navigate("/no-autorizado", { replace: true });
    }
  }, [navigate]);

  const handleLogout = useCallback(() => {
    setUsuario(null);
    setToken(null);
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    navigate("/", { replace: true });
  }, [navigate]);

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        const status = error?.response?.status;
        const message = error?.response?.data?.error || "";
        if (
          status === 401 && (
            message.includes("Token expirado") ||
            message.includes("Token inválido") ||
            message.includes("Usuario dado de baja")
          )
        ) {
          console.warn("🔒 Sesión finalizada por:", message);
          handleLogout();
        }
        return Promise.reject(error);
      }
    );
    return () => axios.interceptors.response.eject(interceptor);
  }, [handleLogout]);

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const storedToken = localStorage.getItem("token");
    if (storedUser && storedToken) {
      setUsuario(JSON.parse(storedUser));
      setToken(storedToken);
    }
    setLoadingPreloader(false);
  }, []);

  const contextValue = useMemo(() => ({
    usuario, token, setUsuario, setToken, handleLogin, handleLogout, loadingPreloader
  }), [usuario, token, loadingPreloader, handleLogin, handleLogout]);

  return (
    <AuthContext.Provider value={contextValue}>
      {children}
    </AuthContext.Provider>
  );
};

AuthProvider.propTypes = {
  children: PropTypes.node,
};

export default AuthProvider;